import * as React from 'react';

import FileKeynote32 from './FileKeynote32';

export const fileKeynote32 = () => <FileKeynote32 />;

export default {
    title: 'Icon/Content/FileKeynote32',
    component: FileKeynote32,
    parameters: {
        notes: "`import FileKeynote32 from 'box-ui-elements/es/icon/content/FileKeynote32';`",
    },
};
